// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZCWPK","input":"styles_input__N3AWw"};